var _path, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInnovacion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,19c0,.5522-.4477,1-1,1,0,1.1046-.8954,2-2,2s-2-.8954-2-2c-.5523,0-1-.4478-1-1s.4477-1,1-1h4c.5523,0,1,.4477,1,1Zm4-10c0,2.7243-1.5574,5.0826-3.8298,6.2386-.6807,.3463-1.1393,1.0036-1.1619,1.7622-.0029,0-.0055-.0009-.0084-.0009h-4c-.0027,0-.0054,.0008-.0081,.0008-.0219-.7546-.4731-1.4132-1.1506-1.7563-2.6454-1.3397-4.3259-4.3074-3.7162-7.5877,.5119-2.7543,2.7182-4.9844,5.4681-5.5197,4.4827-.8725,8.4068,2.5369,8.4068,6.8629Zm-4.6371-.4568h-1.3311c-.3237,0-.5621-.3029-.486-.6174l.553-2.2879c.1157-.4789-.3802-.8386-.7065-.5125l-3.0414,3.0396c-.3044,.3043-.1172,.8796,.2863,.8796h1.2666c.3189,0,.5563,.2946,.4885,.6063l-.5925,2.724c-.106,.4877,.4087,.8314,.7247,.4839l3.14-3.4519c.2842-.3125,.0918-.8636-.3015-.8636Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 39,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by Royyan Wijaya")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 44,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovacion);
export default __webpack_public_path__ + "static/media/innovacion.35a1d4d4806ec89a7af33bf76893354d.svg";
export { ForwardRef as ReactComponent };